import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'

import InboxInfluencerIdentityRow from '@components/Inbox/InfluencerIdentity/Row'
import Loading from '@components/UI/Loading'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import {
  fetchInfluencerIdentitiesUsingNext,
  selectInfluencerIdentitiesHasNextLink,
  selectInfluencerIdentityIdsByCampaignId,
} from '@store/influencerIdentities'
import { Container } from '@tribegroup'

export const InfluencerIdentityList = () => {
  const dispatch = useDispatch()
  const campaignId = useCampaignIdFromRoute() as number

  const influencerIdentityIds = useSelector((state: IApplicationState) =>
    selectInfluencerIdentityIdsByCampaignId(state, campaignId),
  )
  const hasMore = useSelector((state: IApplicationState) =>
    selectInfluencerIdentitiesHasNextLink(state, campaignId),
  )

  const fetchNext = () => {
    dispatch(fetchInfluencerIdentitiesUsingNext(campaignId))
  }

  return (
    <Container bottomInnerSpacing={4.5}>
      <InfiniteScroll
        dataLength={influencerIdentityIds.length}
        next={fetchNext}
        loader={<Loading height={30} />}
        hasMore={hasMore}
        scrollThreshold={0.8}
        style={{ overflow: 'hidden' }}
      >
        <div>
          {influencerIdentityIds.map((influencerIdentityId: number) => (
            <InboxInfluencerIdentityRow
              key={influencerIdentityId}
              influencerIdentityId={influencerIdentityId}
              campaignId={campaignId}
            />
          ))}
        </div>
      </InfiniteScroll>
    </Container>
  )
}

export default InfluencerIdentityList
